import {
  add,
  addMinutes,
  differenceInSeconds,
  format,
  isAfter,
  isSameDay,
  isValid,
  minutesToMilliseconds,
  parseISO,
  startOfWeek,
} from 'date-fns'

export const getStartOfWeek = (date: Date): Date =>
  startOfWeek(date, { weekStartsOn: 1 })

export const isDateAfterHoursInTheFuture = (
  date: Date,
  hours: number,
): boolean => isAfter(date, add(new Date(), { hours }))

// different from date-fns "isFuture(date). The former does not check for isSameDay
export const dateIsInFuture = (date?: Date) => {
  if (date && isValid(date)) {
    const now = new Date()
    const validOnDate = new Date(date?.toDateString())
    if (isSameDay(validOnDate, now) || isAfter(validOnDate, now)) {
      return true
    }
  }
  return false
}

export const getMinuteIntervals = (
  minuteInterval: number,
  amountOfIntervals: number,
  startingFrom = new Date(),
  dateFormat = "yyyy-MM-dd'T'HH:mm:ssxxx",
) => {
  const startDate = new Date(
    Math.floor(startingFrom.getTime() / minutesToMilliseconds(minuteInterval)) *
      minutesToMilliseconds(minuteInterval),
  )
  const fifteenMinuteIntervals = Array.from(
    { length: amountOfIntervals },
    (_, i) => {
      const from = addMinutes(startDate, i * minuteInterval)
      return {
        from: format(from, dateFormat),
        to: format(addMinutes(from, 15), dateFormat),
      }
    },
  )
  return fifteenMinuteIntervals
}

export const getDifferenceInMinutes = (
  minuend: string,
  subtrahend?: string | null,
) => {
  if (!subtrahend) {
    return 0
  }
  const difference = differenceInSeconds(
    parseISO(subtrahend),
    parseISO(minuend),
  )
  if (difference < 0) return 0
  const differenceMin = Math.trunc(difference / 60)
  return differenceMin
}

export const formatMinutes = (minutes?: number, locale = 'en') => {
  if (!minutes) {
    return ''
  }
  const formatter = new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: 'minute',
    unitDisplay: 'short',
  })

  return formatter.format(minutes)
}
